// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1eN-7","emails":"CreateEditClinics_emails__2YfXP","emailTagLabel":"CreateEditClinics_emailTagLabel__1CI6E"};